import React, { useMemo, useState } from "react";
import styled from "@emotion/styled";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import type { FC } from "react";

export interface SeeMoreButtonProps {
  hasMore: boolean;
  onClick: () => void;
}

export const SeeMoreButton: FC<SeeMoreButtonProps> = ({ hasMore, onClick }) => {
  const [isHovering, setIsHovering] = useState(false);

  const textColor = useMemo(() => {
    return isHovering ? MDSTextColor.Primary : MDSTextColor.Secondary;
  }, [isHovering]);

  if (!hasMore) {
    return null;
  }

  return (
    <SeeMoreRow
      onClick={onClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <MDSText variant={MDSTextVariant.TextXs} weight={MDSTextWeight.Medium} color={textColor}>
        See all
      </MDSText>
    </SeeMoreRow>
  );
};

export const SeeMoreRow = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  height: 24px;
  gap: 8px;
  padding: 4px 0;
  align-self: flex-start;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: color 0.08s ease;
  margin-left: 14px;
  margin-bottom: 4px;

  color: ${({ theme }) => theme.colors.text.secondary};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
